import React, { useEffect, useState } from "react";
import { Button, Img, Text } from "components";
import { useTranslation } from "react-i18next";
import { SavedAddressesListItem } from "components/SavedAddressesListItem";
import { updateMyAddress } from "../../../../../redux/reducers/myAddress";
import { useDispatch, useSelector } from "react-redux";
import * as CUSTOM from "../../../../../utils/helper/custom";
import { getAuth } from "../../../../../redux/reducers/loginData";
import {
  updateOrderData,
  getOrderData,
} from "../../../../../redux/reducers/orderData";

// Tab IDs
const DELIVERY_TABS = {
  HOME: "home",
  PICKUP: "pickup",
  GIFT: "gift",
};

const SavedAddressesList = (props) => {
  const {
    addressList,
    zoneList,
    occasionOptions,
    isEventSent,
    setIsEventSent,
    sendCheckoutGaEvent,
    onTabChange, // optional: notify parent of tab switch
    // FIX #1: setAddAddressPopup ab parent (DeliveryMode) se prop ke roop mein
    // aata hai — cart version ki tarah — redux ke zariye nahi
    setAddAddressPopup,
    AddAddressPopup,
  } = props;

  const auth = useSelector(getAuth);
  const dispatch = useDispatch();
  const orderData = useSelector(getOrderData);
  const { t } = useTranslation();

  // Default tab = Delivery Addresses (HOME)
  const [activeDeliveryTab, setActiveDeliveryTab] = useState(
    orderData?.deliveryModeTabIndex === 2
      ? DELIVERY_TABS.PICKUP
      : orderData?.deliveryModeTabIndex === 3
      ? DELIVERY_TABS.GIFT
      : DELIVERY_TABS.HOME
  );

  const [selectedAddressData, setSelectedAddressData] = React.useState({
    homeAddress: {},
    addressIndex: -1,
    selected: false,
  });

  /**
   * Switch tab and notify parent/orderData
   */
  const handleTabSwitch = (tab) => {
    setActiveDeliveryTab(tab);

    // Map to deliveryModeTabIndex so DeliveryMode parent stays in sync
    const tabIndexMap = {
      [DELIVERY_TABS.HOME]: 1,
      [DELIVERY_TABS.PICKUP]: 2,
      [DELIVERY_TABS.GIFT]: 3,
    };

    dispatch(
      updateOrderData({
        ...orderData,
        delivery_mode: "",
        deliveryModeTabIndex: tabIndexMap[tab],
        delivery_type: "",
        deliveryDateTimeActiveTab: 0,
        // FIX #1: Tab switch par addAddressPopup reset karo taaki
        // stale redux value se popup na khule
        addAddressPopup: false,
      })
    );

    if (onTabChange) onTabChange(tab);
  };

  const deliverHear = () => {
    if (!isEventSent?.addShippingInfo) {
      setIsEventSent((prev) => ({ ...prev, addShippingInfo: true }));
      sendCheckoutGaEvent("add_shipping_info");
    }
    dispatch(
      updateOrderData({
        ...orderData,
        pageStep: 3,
        delivery_mode_show: "hide",
        home_office: selectedAddressData?.homeAddress,
        delivery_mode: "home_office",
      })
    );
  };

  // useEffect(() => {
  //   if (selectedAddressData?.selected) {
  //     deliverHear();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedAddressData]);

  
  const handleEditAddress = (addressItem) => {
    // FIX #1: Direct prop call — redux state ke zariye nahi
    if (setAddAddressPopup) {
      setAddAddressPopup(true);
    }
    dispatch(
      updateMyAddress({
        ...CUSTOM.defaultAddressParams(),
        ...addressItem,
        isEdit: true,
      })
    );
    
    // dispatch(updateOrderData({ ...orderData, addAddressPopup: true }));
  };

  
  useEffect(() => {
    if (orderData?.pageStep !== 2) return;

    
    if (
      orderData?.delivery_mode === "home_office" &&
      orderData?.home_office &&
      addressList?.userAddresses?.length
    ) {
      const savedAddressId = orderData?.home_office?.itemDetail?.id;
      const listToSearch =
        auth?.id != 0
          ? addressList?.userAddresses
          : addressList;

      if (listToSearch?.length) {
        const matchingIndex = savedAddressId
          ? listToSearch.findIndex((addr) => addr.id === savedAddressId)
          : -1;

        if (matchingIndex !== -1) {
          setSelectedAddressData({
            homeAddress: {
              address: CUSTOM.buildFullAddress(listToSearch[matchingIndex]),
              itemDetail: listToSearch[matchingIndex],
            },
            addressIndex: matchingIndex,
            
            selected: false,
          });
        } else if (orderData?.home_office?.address) {
          const savedAddr = orderData?.home_office?.itemDetail;
          const matchByFields = savedAddr
            ? listToSearch.findIndex(
                (addr) =>
                  addr.street_name === savedAddr?.street_name &&
                  addr.building_no === savedAddr?.building_no &&
                  addr.flat_no === savedAddr?.flat_no
              )
            : -1;

          if (matchByFields !== -1) {
            setSelectedAddressData({
              homeAddress: {
                address: CUSTOM.buildFullAddress(listToSearch[matchByFields]),
                itemDetail: listToSearch[matchByFields],
              },
              addressIndex: matchByFields,
              selected: false,
            });
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressList, orderData?.pageStep, orderData?.delivery_mode]);

  const tabs = [
    {
      id: DELIVERY_TABS.HOME,
      label: t("deliveryAddresses") || "Delivery Addresses",
      icon: "/images/location_on.svg",
    },
    {
      id: DELIVERY_TABS.PICKUP,
      label: t("pickupPoints") || "Pickup Points",
      icon: "/images/img_location.svg",
    },
    {
      id: DELIVERY_TABS.GIFT,
      label: t("sendGift") || "Send Gift",
      icon: "/images/img_antdesigninfo_black_900.svg",
    },
  ];

  return (
    <>
      <div className="w-full">
        {/* ── Section Title ── */}
        <Text
          className="
            font-medium text-black-900 font-['Unbounded']
            text-[24px] leading-[32px]
            sm:text-[20px] sm:leading-[28px]
            mb-5
          "
        >
          {t("deliveryInformation") || "Delivery Information"}
        </Text>

        {/* ── Tab Bar — matches image: #EFEFEF container, active = white card with shadow ── */}
        <div className="flex flex-row w-full bg-[#EFEFEF] rounded-full p-[5px] mb-6 gap-[4px] overflow-x-auto">
          {tabs.map((tab) => {
            const isActive = activeDeliveryTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabSwitch(tab.id)}
                style={
                  isActive
                    ? {
                        background: "#FFFFFF",
                        boxShadow: "0px 1px 4px 0px rgba(0,0,0,0.15)",
                      }
                    : {
                        background: "transparent",
                      }
                }
                className="flex-1 flex items-center justify-center gap-[6px] px-3 py-[9px] transition-all duration-200 border-0 outline-none cursor-pointer rounded-full"
              >
               
                {tab.icon && (
                  <Img
                    src={tab.icon}
                    alt={tab.label}
                    className="h-[15px] w-[15px] flex-shrink-0"
                    style={{ opacity: isActive ? 1 : 0.38 }}
                  />
                )}
                {/* Label */}
                <span
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "13px",
                    fontWeight: isActive ? 600 : 400,
                    lineHeight: "18px",
                    whiteSpace: "nowrap",
                    color: isActive ? "#1A1A1A" : "#9CA3AF",
                    transition: "all 0.2s",
                  }}
                >
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>

        {/* ── Tab Content ── */}

        {/* Delivery Addresses Tab */}
        {activeDeliveryTab === DELIVERY_TABS.HOME && (
          <div className="flex flex-col gap-4">
            {/* Logged-in user addresses */}
            {auth?.id != 0 && addressList && addressList?.userAddresses?.length ? (
              <SavedAddressesListItem
                addressList={addressList?.userAddresses}
                selectedAddressData={selectedAddressData}
                setSelectedAddressData={setSelectedAddressData}
                onEditAddress={handleEditAddress}
              />
            ) : null}

            {/* Guest addresses */}
            {auth?.id == 0 && addressList && addressList?.userAddresses?.length ? (
              <SavedAddressesListItem
                addressList={addressList}
                selectedAddressData={selectedAddressData}
                setSelectedAddressData={setSelectedAddressData}
                onEditAddress={handleEditAddress}
              />
            ) : null}

            {/* Empty state */}
            {!addressList || !addressList?.userAddresses?.length ? (
              <div className="text-center py-8 text-gray-500 font-['Inter']">
                {t("data_not_found")}
              </div>
            ) : null}

            <div className="w-full h-px bg-gray-200"></div>

            
            <div className="flex items-center justify-between pt-1 gap-4">
              {/* Add New Address button */}
              <button
                className="flex items-center justify-center gap-2 h-[44px] px-6 rounded-full border border-gray-300 bg-[white] text-[#1A1A1A] hover:bg-gray-50 transition"
                onClick={() => {
                
                  if (setAddAddressPopup) setAddAddressPopup(true);
                  dispatch(updateMyAddress(CUSTOM.defaultAddressParams()));
                  // FIX #1: Pehle yahan updateOrderData({...orderData, addAddressPopup: true})
                 
                  // dispatch(updateOrderData({ ...orderData, addAddressPopup: true }));
                }}
              >
                <span className="text-lg leading-none font-[Unbounded]">+</span>
                <span className="text-[#1A1A1A] font-[Unbounded] font-medium text-[14px] leading-[20px] whitespace-nowrap">
                  {t("newAddress") || "New Address"}
                </span>
              </button>

              
              <Button
                disabled={selectedAddressData?.addressIndex === -1}
                className={`h-[44px] px-8 rounded-full text-sm font-medium font-['Unbounded'] transition
                  ${
                    selectedAddressData?.addressIndex !== -1
                      ? "bg-[#BD0043] text-white hover:bg-[#9a0036] cursor-pointer"
                      : "bg-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
                onClick={deliverHear}
              >
                <span className="whitespace-nowrap">
                  {t("selectAddress") || "Select Address"}
                </span>
              </Button>
            </div>
          </div>
        )}

        
        {activeDeliveryTab === DELIVERY_TABS.PICKUP && (
          <div className="flex flex-col gap-4">
            {props?.pickupContent ? (
              props.pickupContent
            ) : (
              <div className="text-center py-8 text-gray-400 font-['Inter'] text-sm">
                
                {t("loading") || "Loading pickup points..."}
              </div>
            )}
          </div>
        )}

        {/* Send Gift Tab — content rendered by parent via prop/slot pattern */}
        {activeDeliveryTab === DELIVERY_TABS.GIFT && (
          <div className="flex flex-col gap-4">
            {props?.giftContent ? (
              props.giftContent
            ) : (
              <div className="text-center py-8 text-gray-400 font-['Inter'] text-sm">
                {/* SendAsAGift is rendered by parent when deliveryModeTabIndex === 3 */}
                {t("loading") || "Loading gift options..."}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SavedAddressesList;
